import React, { ReactElement } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory, generatePath } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import { ListRounded } from '@material-ui/icons';
import { Routes } from 'common/routes/enums';
import styles from './styles.scss';

const LogsButtonComp = (): ReactElement => {
    const history = useHistory();

    const goToLogsPage = () => history.push(generatePath(Routes.logs));

    return (
        <IconButton onClick={goToLogsPage} className={styles.root} title="Журнал логирования">
            <ListRounded />
        </IconButton>
    );
};

export const LogsButton = observer(LogsButtonComp);
